<form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <fieldset [disabled]=processing>
    <app-modal-title>{{title}}</app-modal-title>
    <app-modal-body>
      <div [ngClass]="{'otsc-my-support-form-error': errorState != SFTPAuthErrors.NoError}">
        <ng-scrollbar>
          @switch (errorState) {
          @case (SFTPAuthErrors.ConnectionError) {
          <div class="ot-row">
            <div id="login-error-banner" class="ot-message ot-message--is-error">
              <div class="ot-message__banner">
                <p id="login-connection-error-text" class="ot-message__item">
                  <span i18n>
                    Error connecting to the SFTP site. Please make sure the System Center Manager has internet
                    access. If the issue persists, check the System Center Manager log file for more details.
                  </span>
                </p>
              </div>
            </div>
          </div>
          }
          @case (SFTPAuthErrors.InvalidUsernameOrPassword) {
          <div class="ot-row">
            <div id="login-error-banner" class="ot-message ot-message--is-error">
              <div class="ot-message__banner">
                <p id="login-invalid-auth-error-text" class="ot-message__item">
                  <span i18n>
                    You have entered an invalid user ID, password or your account might be locked.
                    Please try again. If the issue persists, check the System Center Manager log file for more details.
                  </span>
                </p>
              </div>
            </div>
          </div>
          }
          @case (SFTPAuthErrors.InvalidProxyUsernameOrPassword) {
          <div class="ot-row">
            <div id="login-error-banner" class="ot-message ot-message--is-error">
              <div class="ot-message__banner">
                <p id="login-invalid-proxy-auth-error-text" class="ot-message__item">
                  <span i18n>
                    Please make sure the username or password you entered for your proxy server is correct.
                    If the issue persists, check the System Center Manager log file for more details.
                  </span>
                </p>
              </div>
            </div>
          </div>
          }
          @case (SFTPAuthErrors.ProxyConnectionError) {
          <div class="ot-row">
            <div id="login-error-banner" class="ot-message ot-message--is-error">
              <div class="ot-message__banner">
                <p id="login-invalid-proxy-connection-error-text" class="ot-message__item">
                  <span i18n>
                    Please make sure your proxy server can access the SFTP site and review the proxy server logs for
                    more details.
                    If the issue persists, check the System Center Manager log file for more details.
                  </span>
                </p>
              </div>
            </div>
          </div>
          }
          }
          <div id="login" class="ot-mr-1 ot-ml-1 ot-mt-1">
            <p i18n>Sign in to OpenText My Support to upload log packages. Please make sure that System Center Manager
              has internet access. <b>Note:</b> Multiple failed attempts may lock your account.</p>
            <div>
              <div class="ot-form-control">
                <label for="username" class="ot-form-control__label" i18n>User ID</label>
                <input formControlName="username" id="username" class="ot-input" type="text"
                  [attr.disabled]="processing ? true: null">
              </div>
              <div class="ot-form-control">
                <label for="password" class="ot-form-control__label" i18n>Password</label>
                <input formControlName="password" id="password" class="ot-input" type="password"
                  [attr.disabled]="processing ? true: null">
              </div>
            </div>
            @if(isProxyAuthRequired){
            <div>
              <div class="otsc-settings-label otsc-settings-label-desc">Proxy Server Credentials</div>
              <div class="ot-form-control">
                <label for="proxyUsername" class="ot-form-control__label" i18n>User name</label>
                <input formControlName="proxyUsername" id="proxyUsername" class="ot-input" type="text"
                  [attr.disabled]="processing ? true: null">
              </div>
              <div class="ot-form-control">
                <label for="proxyPassword" class="ot-form-control__label" i18n>Password</label>
                <input formControlName="proxyPassword" id="proxyPassword" class="ot-input" type="password"
                  [attr.disabled]="processing ? true: null">
              </div>
            </div>
            }
          </div>
        </ng-scrollbar>
      </div>
    </app-modal-body>
    <app-modal-footer>
      <button id="mysupport-sign-in-button" otsc-button color="primary" type="submit"
        [disabled]="(!loginForm.dirty || loginForm.invalid) || processing" (click)="onSubmit()">
        @if (!processing) {
        <span id="sign-in-button-text" i18n-title title="Sign in" i18n>Sign in</span>
        }
        @if (processing) {
        <div class="ot-progress-container">
          <div id="ot-spinner" class="ot-progress ot-progress--is-spinner">
            <div class="ot-progress__outer">
              <div id="signing-in-spinner" class="ot-progress__meter login-spinner"></div>
              <div id="signing-in-spinner-text" class="ot-progress__text" i18n-title title="Signing in..." i18n>Signing
                in...</div>
            </div>
          </div>
        </div>
        }
      </button>
      <button id="mysupport-cancel-button" otsc-button color="secondary" i18n-title title="Cancel" (click)="onClose()"
        [disabled]="processing" i18n>
        Cancel
      </button>
    </app-modal-footer>
  </fieldset>
</form>